const { cELM, unique } = require("../../utils");

class CallClient {
  constructor(data) {
    this._data = data;
    this.options = this._data.values;
    this.element = cELM("ul", "");
  }

  getELM() {
    return this.element;
  }

  getHTML() {
    this.element.style.listStyle = 'none';
    this.options.forEach(op => {

      const department = cELM("li", "");
      department.style.marginBottom = '30px';
      department.style.fontWeight = '500';
      const address = cELM("div");
      address.innerHTML = op.address;
      const phone = cELM("a");
      phone.href = `tel:${op.phone}`;
      phone.innerText = op.phone
      phone.style.textDecoration = 'underline';
      department.addELM(address);
      department.addELM(phone);
      
      this.element.addELM(department);
    });

    return this.element;
  }

  reset() {
    let sibling = this.element.firstChild;
    while (sibling) {
      sibling.classList.remove("option-active");
      sibling = sibling.nextSibling;
    }
    this.selectedOptions = [];
  }

  focus() {}
}

module.exports = CallClient;
